import script from "./BusView.vue?vue&type=script&setup=true&lang=js"
export * from "./BusView.vue?vue&type=script&setup=true&lang=js"

import "./BusView.vue?vue&type=style&index=0&id=09f277aa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f277aa"]])

export default __exports__